import { observer } from 'mobx-react';
import * as React from 'react';
import { Route, RouteComponentProps } from 'react-router';
import { UserEdit } from './UserEdit';
import { UsersList } from './UsersList';

export interface IUsersViewProps extends RouteComponentProps<undefined> {}

@observer
export class UsersView extends React.Component<IUsersViewProps> {
    public render() {
        return (
            <>
                <Route path="/users/:userRoleView" exact component={UsersList} />
                <Route path="/users/:id/edit" component={UserEdit} />
            </>
        );
    }
}
